module.exports = __webpack_public_path__ + "img/apple4.b7e3d3eb.png";